/* Blackheath header: mobile drawer + accordion mega-menus. */
(function () {
  function boot() {
    var header = document.querySelector('[data-bhs-header]');
    if (!header) return;
    var burger = header.querySelector('[data-bhs-burger]');
    var nav = header.querySelector('[data-bhs-nav]');
    var scrim = document.querySelector('[data-bhs-scrim]');
    var mq = window.matchMedia('(max-width: 989px)');

    function openDrawer(open) {
      if (!nav) return;
      nav.classList.toggle('is-open', open);
      if (scrim) scrim.hidden = !open;
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }
    if (burger) burger.addEventListener('click', function () { openDrawer(!nav.classList.contains('is-open')); });
    if (scrim) scrim.addEventListener('click', function () { openDrawer(false); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') openDrawer(false); });

    /* Accordion on mobile: tapping a top link toggles its mega instead of navigating */
    header.querySelectorAll('[data-bhs-top]').forEach(function (top) {
      top.addEventListener('click', function (e) {
        if (!mq.matches) return; // desktop: let it navigate (hover opens mega)
        var item = top.closest('.bhs-nav__item');
        if (!item || !item.querySelector('.bhs-mega')) return;
        e.preventDefault();
        var open = item.classList.contains('is-open');
        header.querySelectorAll('.bhs-nav__item.is-open').forEach(function (i) { if (i !== item) i.classList.remove('is-open'); });
        item.classList.toggle('is-open', !open);
      });
    });

    /* Reset drawer state when crossing the breakpoint */
    mq.addEventListener('change', function () { openDrawer(false); header.querySelectorAll('.bhs-nav__item.is-open').forEach(function (i) { i.classList.remove('is-open'); }); });
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
